module.exports = __webpack_public_path__ + "static/media/unblock.f9292b91.svg";